var __rspack_ns_object = JSON.parse('{"TITLE":"Holds","PAST_HOLDS":{"TITLE":"Holds for past shows"},"UPCOMING_HOLDS":{"TITLE":"Holds for upcoming shows"}}')